import React, { useRef } from 'react'
import PersonChangesInfiniteScrolling from './PersonChangesInfiniteScrolling'

export default function PersonChangesTable({
  personId,
  personChangesState,
  personChangesDispatch,
  rerenderInfiniteScroll,
  setRerenderInfiniteScroll,
  filtersState,
}) {
  const triggerRef = useRef()
  const containerRef = useRef()

  if (!personChangesState || !personChangesState.changes) {
    return null
  }

  return (
    <>
      <div ref={containerRef}>
        <PersonChangesInfiniteScrolling
          personId={personId}
          personChangesDispatch={personChangesDispatch}
          personChangesState={personChangesState}
          containerRef={containerRef}
          triggerRef={triggerRef}
          rerenderInfiniteScroll={rerenderInfiniteScroll}
          setRerenderInfiniteScroll={setRerenderInfiniteScroll}
          filtersState={filtersState}
        />
      </div>
      <div ref={triggerRef}> </div>
    </>
  )
}
